<template>
  <div
    class="summary-preview cursor-pointer"
    data-qa="basket-preview-list"
    role="button"
    tabindex="0"
    @click="emit('open')"
    @keydown.enter="emit('open')"
    @keydown.space.prevent="emit('open')"
  >
    <div class="summary-preview-row">
      <SummaryItemThumb
        v-for="item in previewItems"
        :key="item.article"
        :item="item"
        qa-prefix="basket-preview"
      />
      <div
        v-if="hasMore"
        class="summary-preview-more"
        data-qa="basket-preview-more-btn"
      >
        <span class="summary-preview-more-inner">{{ '+ ' + hiddenCount }}</span>
      </div>
    </div>
    <p class="summary-preview-counter" data-qa="basket-summary-counter">
      {{ counterText }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import SummaryItemThumb from '@/components/summary/SummaryItemThumb.vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  counterText: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['open'])

const sumQuantity = (items) =>
  items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)

const previewItems = computed(() => props.items.slice(0, 3))
const hasMore = computed(() => props.items.length > 3)
const hiddenCount = computed(
  () => sumQuantity(props.items) - sumQuantity(previewItems.value)
)
</script>

<style scoped lang="scss">
.summary-preview-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 120px));
  gap: 16px;
}

.summary-preview-more {
  width: 100%;
  min-width: 0;
  aspect-ratio: 74 / 64;
  box-sizing: border-box;
  padding: 2px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #8e9aa4;
  border-radius: 4px;
}

.summary-preview-more-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  border-radius: 2px;
  color: #75828b;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  letter-spacing: -0.014em;
}

.summary-preview-counter {
  margin: 0;
  padding: 8px 0 16px;
  color: #75828b;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: -0.014em;
}
</style>
